import { render, staticRenderFns } from "./dashboardFollowup.vue?vue&type=template&id=5f5ecf3a"
import script from "./dashboardFollowup.vue?vue&type=script&lang=js"
export * from "./dashboardFollowup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports